import React from 'react';
import DefaultMaterialTable from '../../../../../common/DefaultMaterialTable';
import getColumns from './columns';

function Items({ values, query, setInvoice, filterBtn, loading, setValues, report }) {
    const filters = query;
    const columns = getColumns(setInvoice);

    return (
        <DefaultMaterialTable
            title={'Account Balances'}
            filters={filters}
            columns={columns}
            data={values}
            options={{ sorting: true }}
            filterBtn={filterBtn}
            loading={loading}
            setValues={setValues}
            canShowFilters={false}
            showFiltersOnHeader={false}
            report={report}
        />
    );
}

export default Items;
